export default __webpack_public_path__ + "static/media/6.b5186a13.svg";